
import Formsy from 'formsy-react'
import React, { Component } from 'react'
import SellerStripeFormUpdated from '../SellerStripeFormUpdated'
import InvoiceSection from '../InvoiceSection'
import './BillingInfo.less'
import { ElementsConsumer } from '@stripe/react-stripe-js'
import ErrorBox from '../ErrorBox'
import { Modal } from 'semantic-ui-react'
import DGTextbox from '../../FormControls/Textbox/DGTextbox'
import { pageView } from '../../../common/analytics'
import DisclaimerSection from '../../DisclaimerSection/DisclaimerSection'
import dedicatedCustomer from '../../../assets/images/newui/dedicated-customer.svg'
import { isValidCellNumber, isValidEmail } from '../../../helpers/validation';
import { sendLoginEmail, verifyEmail } from '../../../services/User';
import next from '../../../assets/images/newui/sellersignup/next-btn.svg'
import { format } from 'react-phone-input-auto-format'
import { alertBusinessDetailsCompleted, newLeadAlert } from '../../../services/Seller'

let debounceTimer;
class BillingInfo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingEmailCheck: false,
            disabledEmailTextbox: false,
            emailTextChanged: false,
            showExistingEmailModal: false,
            hidePaymentDetails: true,
            isPhoneValid: false,
            isEmailValid: false,
            isBusinessDetailsFormSubmittedOnce: false,
            previousSubmittedBusinessDetails: []
        }
    }

    onFormFieldChange = () => {
        if (!this.state.hidePaymentDetails) {
            return;
        }

        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        debounceTimer = setTimeout(this.validateFormAndSendAlert, 2000)
    }

    validateFormAndSendAlert = () => {
        if (!this.props.email || !isValidEmail("", this.props.email) || !this.props.phone || !isValidCellNumber("", this.props.phone)) {
            return;
        }

        const alertDetails = {
            email: this.props.email,
            phone: `<tel:${this.props.phone.replace('-', '').replace('(', '').replace(')', '')}>`,
            contactName: this.props.contactName,
            category: this.props.selectedCategory.name
        }

        for (const bd of this.state.previousSubmittedBusinessDetails) {
            if (JSON.stringify(bd) === JSON.stringify(alertDetails)) {
                return;
            }
        }

        this.setState({ previousSubmittedBusinessDetails: [...this.state.previousSubmittedBusinessDetails, alertDetails] });
        alertBusinessDetailsCompleted(alertDetails);
    }

    async componentDidMount() {
        pageView('/billingInfo', 'Company Details');
    }

    verifySellerEmail = async (e) => {
        let value = e.target.value;
        if (this.state.emailTextChanged) {
            const isValid = isValidEmail("", value);
            if (isValid) {
                // now check for duplicate email from;
                this.setState({ loadingEmailCheck: true, disabledEmailTextbox: true })
                const res = await verifyEmail(value);
                if (res.resStatus == 400) {
                    // already exist
                    let orignalURl = '/add-subscription/' + this.props.selectedPlan.plan.planID;
                    await sendLoginEmail(value, orignalURl);
                    this.setState({ showExistingEmailModal: true })
                }
                this.setState({ loadingEmailCheck: false, disabledEmailTextbox: false, emailTextChanged: false })
            }
        }
    }

    closeExistingEmailNotificationModal = () => {
        this.props.onChange({ email: String('').trim() })
        this.setState({ showExistingEmailModal: false })
    }

    handlePhoneChange = (e, { value }) => {
        this.props.onChange({ phone: format(value) })
        this.onFormFieldChange()
    }

    onPhoneKeyDown = (evt) => {
        if (evt.key != 'Backspace' && evt.key != 'Delete' && evt.key != 'Tab') {
            var patt = new RegExp(/^[0-9\b]+$/);
            var res = patt.test(evt.key);
            if (!res)
                evt.preventDefault()
        }
    }

    onContinueButtonClick = (e) => {
        if (!this.props.email || !isValidEmail("", this.props.email) || !this.props.phone || !isValidCellNumber("", this.props.phone)) {
            this.setState({ isBusinessDetailsFormSubmittedOnce: true });
            return;
        }
        
        this.setState({ hidePaymentDetails: false })
        e.preventDefault();

        let alertDataMessage = `phone: ${`<tel:${this.props.phone.replace('-', '').replace('(', '').replace(')', '')}>`}, email: ${this.props.email}, contactName: ${this.props.contactName}, category: ${this.props.selectedCategory.name}`;
        newLeadAlert({alertDataMessage});
    }

    render() {
        const { hasBasicInfoForm } = this.props;
        return <div className="billing-info-container">
            {window.innerWidth <= 1200 && this.props.selectedCategory && this.props.selectedCategory.freeTrial ? <div className='free-trial-image-container'>
                <div className='billing-info-header'><span>{/*Start Getting Tows Today*/}</span></div>
                <div className='free-trial-image'>
                    <img src={this.props.selectedCategory.freeTrial.URL} />
                </div>
            </div> : ""}
            <div className={`billing-info-header${this.props.selectedCategory && this.props.selectedCategory.freeTrial ? "" : " margin-top"}`}>
                <span>{this.props.selectedCategory ? this.props.selectedCategory.checkoutHeading || "Get New Customers Delivered Straight to Your Inbox Each Week!" : ''}</span>
                {this.props.cardError && window.innerWidth >= 1200 ? <div><ErrorBox message={this.props.cardError} /></div> : ''}
            </div>
            <Formsy onValidSubmit={this.props.onSubmit}>
                <div className='billing-info-form' style={window.innerWidth > 1200 && (!this.props.selectedCategory || !this.props.selectedCategory.freeTrial) ? { width: '40%' } : {}}>
                    <div className='basic-info-form-section'>
                        <div className='basic-info-form-heading'>
                            Business Details
                        </div>
                        <div className='basic-info-form'>
                            <div className='basic-info-form-item'>
                                <DGTextbox
                                    tabIndex={1}
                                    placeholder="John Smith" name="contactName" label="Contact Name" required
                                    maxLength={100}
                                    validationErrors={{
                                        isDefaultRequiredValue: 'Contact Name is required',
                                        isNotBlankString: `Contact Name is required`,

                                    }}
                                    validations={{
                                        isNotBlankString: true
                                    }}
                                    onChange={(e, { name, value }) => {
                                        this.props.onChange({ [name]: value })
                                        this.onFormFieldChange()
                                    }}
                                    value={this.props.contactName}
                                />
                            </div>
                            <div style={{ marginBottom: '10px', width: '100%' }}>
                                <DGTextbox name="phone" label="Phone Number" placeholder="" required type="text"
                                    tabIndex={2}
                                    maxLength={14}
                                    validations={{
                                        isValidCellNumber: true
                                    }}
                                    validationErrors={{
                                        isDefaultRequiredValue: 'Phone Number is required',
                                        isValidCellNumber: 'Invalid Phone Number'
                                    }}
                                    onChange={this.handlePhoneChange}
                                    onKeyDown={this.onPhoneKeyDown}
                                    value={this.props.phone || ""}

                                />
                            </div>
                            <div className='basic-info-form-item'>
                                <DGTextbox
                                    name="email"
                                    label="Email"
                                    placeholder="john@starent.com"
                                    required type="text"
                                    tabIndex={3}
                                    innerRef={(c) => {
                                        this.emailRef = c;
                                    }}
                                    maxLength={100}
                                    validations={{
                                        isValidEmail: true,
                                        maxLength: 100
                                    }}
                                    validationErrors={{
                                        isDefaultRequiredValue: 'Email is required',
                                        maxLength: 'Email should not exceed 100 characters.',
                                        isValidEmail: 'Enter a valid email.'
                                    }}
                                    onBlur={(e) => this.verifySellerEmail(e)}
                                    onChange={(e, { name, value }) => {
                                        this.props.onChange({ [name]: String(value || '').trim() })
                                        this.setState({ emailTextChanged: true })
                                        this.onFormFieldChange()
                                    }}
                                    value={this.props.email}
                                    showLoader={this.state.loadingEmailCheck}
                                    disabled={this.state.disabledEmailTextbox}
                                />
                            </div>
                        </div>
                        {this.state.hidePaymentDetails && <button className='continue-btn' onClick={this.onContinueButtonClick} >Continue<img src={next} /></button>}
                    </div>
                    {!this.state.hidePaymentDetails && window.innerWidth <= 677 &&
                        <div className='invoice-form-section mobile'>
                            {this.props.selectedPlan ? <>
                                <InvoiceSection
                                    selectedCategory={this.props.selectedCategory}
                                    planType={this.props.selectedPlan.plan.planType.toLowerCase()}
                                    planPrice={this.props.selectedPlan.plan.price}
                                    commission={this.props.selectedPlan.plan.commission}
                                    referralFee={this.props.selectedPlan.plan.referralFee}
                                    planName={this.props.selectedPlan.plan.planName}
                                    features={this.props.selectedPlan.features}
                                    onChange={this.props.onChange}
                                    isTrialPlan={this.props.selectedPlan.plan.trialDays}
                                    activeTabIndex={this.props.activeTabIndex}
                                    isBottomHidden
                                    isCommissionOnly={this.props.selectedPlan.plan.commissionOnly}
                                />
                            </> : ''}
                        </div>
                    }
                    {this.props.selectedPlan && (!this.props.selectedPlan.plan.trialDays || this.props.selectedPlan.plan.requiresPaymentMethod) ? this.state.hidePaymentDetails ? "" : <div className='stripe-form-section'>
                        <SellerStripeFormUpdated plan={this.props.selectedPlan ? this.props.selectedPlan.plan : {}} onChange={this.props.onChange} stripe={this.props.stripe} elements={this.props.elements} isSmall={hasBasicInfoForm} />
                    </div> : window.innerWidth > 1200 ? <DisclaimerSection buttonText={this.props.selectedPlan && this.props.selectedPlan.plan.trialDays ? 'Start Trial' : 'GO'} /> : ''}
                </div>
                {this.state.hidePaymentDetails ? "" : <div className='invoice-form-section' style={window.innerWidth > 1200 && (!this.props.selectedCategory || !this.props.selectedCategory.freeTrial) ? { width: '60%' } : {}}>
                    {this.props.selectedPlan ? <>
                        <InvoiceSection
                            selectedCategory={this.props.selectedCategory}
                            planType={this.props.selectedPlan.plan.planType.toLowerCase()}
                            planPrice={this.props.selectedPlan.plan.price}
                            commission={this.props.selectedPlan.plan.commission}
                            referralFee={this.props.selectedPlan.plan.referralFee}
                            planName={this.props.selectedPlan.plan.planName}
                            features={this.props.selectedPlan.features}
                            onChange={this.props.onChange}
                            isTrialPlan={this.props.selectedPlan.plan.trialDays}
                            activeTabIndex={this.props.activeTabIndex}
                            isTopHidden={window.innerWidth <= 677}
                            isCommissionOnly={this.props.selectedPlan.plan.commissionOnly}
                        />
                        {this.props.cardError && window.innerWidth < 1200 ? <div><ErrorBox message={this.props.cardError} /></div> : ''}
                        {window.innerWidth > 1200 ? '' : <DisclaimerSection isTrialPlan={this.props.selectedPlan.plan.trialDays} planPrice={this.props.selectedPlan.plan.price} buttonText={this.props.selectedPlan.plan.trialDays ? 'Start Trial' : 'GO'} />}
                    </> : ''}
                </div>}
                {window.innerWidth > 1200 && this.props.selectedCategory && this.props.selectedCategory.freeTrial ? <div className={`bussiness-acquisition-page${this.state.hidePaymentDetails ? " full-width" : ""}`}>
                    <div className="bussiness-acquisition-page-header">
                        {/*<img src={dedicatedCustomer} />
                        <span>Start Getting Tows Today</span>*/}
                    </div>
                    <div className='bussiness-acquisition-page-img'>
                        <img src={this.props.selectedCategory.freeTrial.URL} />
                    </div>
                </div> : ''}
            </Formsy>


            <Modal open={this.state.showExistingEmailModal}
                closeIcon={true}
                closeOnDimmerClick={false}
                onClose={this.closeExistingEmailNotificationModal}
                className={"existing-email-notification-modal "}>
                <Modal.Content>
                    <div className="main-msg">
                        Welcome Back
                    </div>
                    <div className="sub-msg">
                        You have an existing account with us. Please tap/click on the "Login" link in the email that we just sent you at
                        <br />  <div className={"email"}> <b>"{this.props.email}"</b> </div> <br />
                        Close this to register with a different email address.
                    </div>
                </Modal.Content>
            </Modal>
        </div>
    }
}

const InjectedBillingInfo = (additionalProps) => (
    <ElementsConsumer>
        {({ stripe, elements }) => (
            <BillingInfo stripe={stripe} elements={elements} {...additionalProps} />
        )}
    </ElementsConsumer>
);


export default InjectedBillingInfo;